import { Pipe, PipeTransform, Injectable } from '@angular/core';
/*
 * Date to week converter
 * Usage:
 *   value | week:date
 * Example:
 *   {{ date | week }}
 *   formats to: #
*/
@Pipe({ name: 'week' })
export class WeekPipe implements PipeTransform {
  transform(value: Date): number {
    let d : Date = new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()));
    let dayNum : number = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);

    // First january.
    let yearStart: Date = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));

    // 86400000 = milliseconds in one day.
    return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7)
  }
}
